import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout/ Layout";
import BlogPage from "./pages/BlogPage";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/page" element={<BlogPage />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
